import type { Image, SliderGalleryData, SliderGalleryDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { getImageProps } from '../../core/carmi/Image/Image'

export const props = withCompInfo<any, SliderGalleryDefinition>()(
	['compData', 'experiments'],
	({ compData, experiments }) => {
		const { items } = compData as SliderGalleryData
		const itemsProps = items.map((item) => {
			const { link = {}, id, title, description } = item as any
			return {
				image: getImageProps(item as Image, { displayMode: 'fill' }, experiments),
				link,
				id,
				dataId: id,
				title,
				description,
			}
		})
		return {
			itemsProps,
		}
	}
)
